import { Action } from 'redux';
import { LogSummary, TrackedLink, LinkContacts, BouncedCategorySummary } from '@dev/ee-api/ee-api-models';
import { SummaryParams, ExportLinksParams, ExportLinkContactsParams, LinkContactsParams } from '@api/services/ElasticApi';
import { Dayjs } from 'dayjs';

export interface StdLoadSummaryInterface extends SummaryParams {
    summaryLoading?: boolean;
    todaySummaryLoading?: boolean;
}

export enum BouncedSummaryTypes {
    LOAD = '@@statistics/LOAD_BOUNCED_SUMMARY',
    SUCCESS = '@@statistics/LOAD_BOUNCED_SUMMARY_SUCCESS',
}

export interface LoadBouncedSummaryAction extends Action {
    type: BouncedSummaryTypes.LOAD;
    payload: {
        from: string;
        to: string;
        channelName: string;
    };
}

export interface LoadBouncedSummarySuccessAction extends Action {
    type: BouncedSummaryTypes.SUCCESS;
    payload: { bouncedSummary: BouncedCategorySummary | null };
}

export interface LoadSummaryFetchStartAction extends Action {
    type: '@@statistics/LOADSUMMARY_FETCH_START';
    payload: StdLoadSummaryInterface;
}
export interface LoadSummaryFetchSuccessAction extends Action {
    type: '@@statistics/LOADSUMMARY_FETCH_SUCCESS';
    payload: {
        summary: LogSummary;
        summaryLoading: boolean;
    };
}
export interface LoadSummaryFetchErrorAction extends Action {
    type: '@@statistics/LOADSUMMARY_FETCH_ERROR';
    payload: {
        summaryLoading: boolean;
    };
}

export interface LoadTodaySummaryFetchStartAction extends Action {
    type: '@@statistics/LOADTODAYSUMMARY_FETCH_START';
    payload: StdLoadSummaryInterface;
}
export interface LoadTodaySummaryFetchSuccessAction extends Action {
    type: '@@statistics/LOADTODAYSUMMARY_FETCH_SUCCESS';
    payload: {
        todaySummary: LogSummary;
        todaySummaryLoading: boolean;
    };
}
export interface LoadTodaySummaryFetchErrorAction extends Action {
    type: '@@statistics/LOADTODAYSUMMARY_FETCH_ERROR';
    payload: {
        todaySummaryLoading: boolean;
    };
}

export interface LoadLinkTrackingListFetchStartAction extends Action {
    type: '@@statistics/LOADLINKTRACKING_START';
    payload: {
        activePage?: number;
        linkSearch?: string;
        channelName: string;
        linktrackingLoading: boolean;
        from?: string;
        to?: string;
        perPage?: number;
    };
}
export interface LoadLinkTrackingListFetchSuccessAction extends Action {
    type: '@@statistics/LOADLINKTRACKING_SUCCESS';
    payload: {
        linktrackingLoading: boolean;
        linkTrackingList: TrackedLink[];
        totalLinkCount?: number;
        linkTrackingActivePage?: number;
        linkTrackingPerPage?: number;
    };
}
export interface LoadLinkTrackingFetchErrorAction extends Action {
    type: '@@statistics/LOADLINKTRACKING_ERROR';
    payload: {
        linktrackingLoading: boolean;
    };
}

export interface FindLinkTrackingAction extends Action {
    type: '@@statistics/LINKTRACKING_SEARCH';
    payload: {
        activePage?: number;
        linkSearch?: string;
        channelName: string;
        linktrackingLoading: boolean;
        from?: string;
        to?: string;
        perPage?: number;
    };
}

export interface ExportLinksAction extends Action {
    type: '@@statistics/EXPORT_LINKS';
    payload: ExportLinksParams;
}
export interface ExportLinksStartAction extends Action {
    type: '@@statistics/EXPORT_LINKS_START';
}
export interface ExportLinksErrorAction extends Action {
    type: '@@statistics/EXPORT_LINKS_ERROR';
}
export interface ExportLinksSuccessAction extends Action {
    type: '@@statistics/EXPORT_LINKS_SUCCESS';
}

export interface LoadLinkContactsStartAction extends Action {
    type: '@@statistics/LINKCONTACTS_START';
    payload: LinkContactsParams;
}
export interface LoadLinkContactsSuccessAction extends Action {
    type: '@@statistics/LINKCONTACTS_SUCCESS';
    payload: {
        linkContactsLoading: boolean;
        linkContactsList: LinkContacts;
        totalLinkContactsCount?: number;
        linkContactsActivePage?: number;
        linkContactsPerPage?: number;
    };
}
export interface LoadLinkContactsErrorAction extends Action {
    type: '@@statistics/LINKCONTACTS_ERROR';
    payload: {
        linkContactsLoading: boolean;
    };
}

export interface ExportLinkContactsAction extends Action {
    type: '@@statistics/EXPORT_LINKCONTACTS';
    payload: ExportLinkContactsParams;
}
export interface ExportLinkContactsStartAction extends Action {
    type: '@@statistics/EXPORT_LINKCONTACTS_START';
}
export interface ExportLinkContactsErrorAction extends Action {
    type: '@@statistics/EXPORT_LINKCONTACTS_ERROR';
}
export interface ExportLinkContactsSuccessAction extends Action {
    type: '@@statistics/EXPORT_LINKCONTACTS_SUCCESS';
}

export interface StatisticsState {
    summaryLoading?: boolean;
    todaySummaryLoading?: boolean;
    summary?: LogSummary;
    todaySummary?: LogSummary;
    linkTrackingList?: TrackedLink[];
    linktrackingLoading?: boolean;
    totalLinkCount?: number;
    totalLinkContactsCount?: number;
    linkTrackingActivePage?: number;
    linkTrackingPerPage?: number;
    linkContactsActivePage?: number;
    linkContactsPerPage?: number;
    linkContactsLoading?: boolean;
    linkContactsList?: LinkContacts;
    bouncedSummary?: BouncedCategorySummary;
}

export interface LinkTrackingState {
    tabValue: number;
    tableBtnValue: string;
    exportOptions: ExportLinksParams;
    from: Dayjs;
    to: Dayjs;
    dateRangeValue: number | string;
}

export interface LinkContactsState {
    exportOptions: ExportLinksParams;
    from: Dayjs;
    to: Dayjs;
    dateRangeValue: number | string;
    link?: string;
}
